import { setDefaultFilters } from '../utils/filters';
import { mapFilterOptionsToGetters } from '../utils/vehicleFilters';
import * as constants from '../constants';

const defaultFilters = {
  id: 0,
  searchType: '',
  vehicleId: 0,
  month: '',
  year: '',
  equipmentList: [],
  vehicleKeyList: [],
  transmissionType: '',
  brandId: 2,
  vehicleType: 'PKW',
};

const defaultVehicleFilters = {
  brandId: null,
  category: null,
  catalog: null,
  serie: null,
  bodyId: null,
  modelId: null,
  engineId: null,
  versionList: [],
  year: null,
  month: null,
  transmissionId: null,
  steeringId: null,
  typeId: null,
};

const getters = {
  categoriesPath: (state) => state.categoriesPath,
  vehicleCurrentFilters: (state) => state.vehicleCurrentFilters,
  categories: (state) => state.categories,
  conditions: (state) => setDefaultFilters(state.conditions, state.vehicleData?.EquipmentList),
  boards: (state) => state.boards,
  board: (state) => state.board,
  hotspots: (state) => state.hotspots,
  searchData: (state) => state.searchData,
  searchDataCurrent: (state) => state.searchDataCurrent,
  vehicleData: (state) => state.vehicleData,
  vehicleTabs: ({ vehicleData }) => {
    const {
      VehicleData,
      VehicleFuelQty,
      StandardEquipment,
      OptionalEquipment,
      TechnicalCampaigns,
    } = vehicleData;

    return [
      {
        title: 'Vehicle data',
        tables: [
          {
            tableHeaders: ['Name', 'Value'],
            tableRows: Object.keys(VehicleData).map((item) => [
              { value: item },
              { value: VehicleData[item] },
            ]),
          },
        ],
      },
      {
        title: 'Vehicle Fuel Qty',
        tables: [
          {
            tableHeaders: ['Filling quantity for', 'Replacement volume in litres', 'Note'],
            tableRows: VehicleFuelQty
              ? VehicleFuelQty.map((item) => [
                { value: item.fuellmengenart },
                { value: item.fuellmenge },
                { value: item.hinweistext },
              ])
              : [],
          },
        ],
      },
      {
        title: 'Equipment',
        tables: [
          {
            title: 'Standard Equipment',
            tableHeaders: ['Code', 'Name'],
            tableRows: StandardEquipment
              ? StandardEquipment.map((item) => [
                { value: item.code, mark: item.nachgeruestet },
                { value: item.benennung, mark: item.nachgeruestet },
              ])
              : [],
          },
          {
            title: 'Optional Equipment',
            tableHeaders: ['Code', 'Name'],
            tableRows: OptionalEquipment
              ? OptionalEquipment.map((item) => [
                { value: item.code, mark: item.nachgeruestet },
                { value: item.benennung, mark: item.nachgeruestet },
              ])
              : [],
          },
        ],
      },
      {
        title: 'Technical Campaigns',
        tables: [
          {
            tableHeaders: ['Status', 'Campaigns No.', 'Description', 'Reservations'],
            tableRows: TechnicalCampaigns
              ? TechnicalCampaigns.map((item) => [
                { value: item.Status },
                { value: item.CampaignNumber },
                { value: item.Description },
                { value: item.Reservations },
              ])
              : [],
          },
        ],
      },
    ];
  },
  defaultFilters: () => defaultFilters,
  defaultVehicleFilters: () => defaultVehicleFilters,
  filters: (state) => ({
    ...defaultFilters,
    year: state.vehicleData?.Year || '',
    month: state.vehicleData?.Month || '',
    vehicleId: state.vehicleData?.VehicleId || '',
    vehicleKeyList: state.vehicleData?.VehicleKeyList || [],
    equipmentList: state.vehicleData?.EquipmentList || [],
    vehicleType: state.vehicleData?.VehicleType || 'PKW',
    transmissionType: state.vehicleData?.TransmissionType || '',
  }),
  ...mapFilterOptionsToGetters(constants.vehicleFiltersBasicTypes),
  ...mapFilterOptionsToGetters(constants.vehicleFiltersVehicleTypes),
};

export default getters;
